import React from "react";
import { translate } from "react-i18next";

import { Container } from "./styles";

const NotFound = ({ t }) => (
  <Container>
    <span>{t("pageNotFound")}</span>
  </Container>
);

export default translate("translations")(NotFound);
